"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopCleanupJob = exports.startCleanupJob = void 0;
var is_expired_1 = require("./is-expired");
var log_1 = require("./log");
function startCleanupJob(state, opts) {
    if (!state.cleanupInterval && !opts.staleWhileRevalidate) {
        log_1.log(opts, "Starting cleanup job every " + opts.cleanupInterval + " ms");
        state.cleanupInterval = setInterval(function () {
            cleanup(state, opts);
        }, opts.cleanupInterval);
    }
}
exports.startCleanupJob = startCleanupJob;
function stopCleanupJob(state, opts) {
    if (state.cleanupInterval) {
        log_1.log(opts, 'Stopping cleanup job');
        clearInterval(state.cleanupInterval);
        state.cleanupInterval = undefined;
    }
}
exports.stopCleanupJob = stopCleanupJob;
function cleanup(state, opts) {
    var e_1, _a;
    var removeableKeys = [];
    try {
        for (var _b = __values(state.cacheMap.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (is_expired_1.isExpired(opts, value)) {
                removeableKeys.push(key);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (removeableKeys.length > 0) {
        log_1.log(opts, "Expired keys: " + removeableKeys);
        removeableKeys.forEach(function (key) {
            state.cacheMap.delete(key);
        });
    }
    if (state.cacheMap.size === 0) {
        stopCleanupJob(state, opts);
    }
}
//# sourceMappingURL=cleanup.js.map